import React from 'react'
import "./HomePage.css"
import { colors } from '@mui/material'

function UpcomingLecInsPopup({ handleClosePopup, popupText, popupTitleText, reduceParagraphLength }) {

    const popupheadtextstyle = {
        fontSize: "22px",
        lineHeight: "30px",
        fontWeight: "500",
        background: "#F77F00",
        color: "#ffffff",
        padding: "5px 10px",
        borderRadius: "5px"
    }
    const popupdtitletextstyle = {
        fontSize: "22px",
        lineHeight: "30px",
        fontWeight: "500",
        color: "#ffffff",
        padding: "2px",
        borderRadius: "5px"
    }

    const popuptextstyle = {
        fontSize: "20px",
        lineHeight: "30px",
        fontWeight: "500",
        textAlign: "justify",
        padding: "2px 10px"
    }
    return (
        <div className="successful_create_transprant_body">
            <img
                style={{ position: "absolute", top: "25%", right: "30%" }}
                src="/images/cross.svg"
                className="btn-light p-2 rounded-circle"
                alt=""
                onClick={handleClosePopup}
            />
            <div className=" p-2 successful_create_container-popup shadow">
                <div style={popupheadtextstyle}>Lecture Instruction | <span style={popupdtitletextstyle}>{reduceParagraphLength(popupTitleText, 15)}</span></div>
                <span className="my-2 successfully_create_message" style={popuptextstyle}>
                    {popupText}
                </span>

            </div>
        </div>
    )
}

export default UpcomingLecInsPopup